import { createSvg } from '../createSvg';

const Two = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'contour'}>
                <path
                    d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <g id={'guts'}>
                <path
                    d='M13.4404 9.38512C13.4404 10.4091 12.7684 10.9531 11.3604
            11.9131L7.2324 14.7131V16.8571H16.0324V14.6011H10.9764L13.0884
            13.2091C14.8324 12.0571 15.9684 11.0011 15.9684 9.30512C15.9684
            7.16112 14.4164 5.81712 11.7444 5.81712C9.0084 5.81712 7.4244 7.25712
            7.0564 9.33712L9.4724 9.80112C9.7284 8.64912 10.4964 7.96112 11.7124
            7.96112C12.8644 7.96112 13.4404 8.56912 13.4404 9.38512Z'
                />
            </g>
        </>
    );
};

export default createSvg(
    Two,
    'two',
);
